// import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';

// // --------------------
// // Types & Interfaces
// // --------------------

// interface ParticipantsPayload {
//   group_id: string;
//   service_name_id: string;
//   nested_component_id: string;
//   email: string;
//   roles: string[];
//   client_name: string;
// }

// interface ParticipantsResponse {
//   participants_list: { name: string; email: string; avatar?: string; ndisNumber?: string }[];
// }

// interface Client {
//   label: string;
//   id: number;
//   email: string;
//   avatar?: string;
//   ndisNumber?: string;
// }

// interface ProjectState {
//   selectedProject: string | null;
//   selectedProjectId: string | null;
//   selectedClient: Client | null;
//   participants: ParticipantsResponse;
//   loading: boolean;
//   error: string | null;
//   isAdmin: boolean;
// }

// // --------------------
// // Initial State
// // --------------------

// const persistedState: ProjectState = (() => {
//   const stored = localStorage.getItem('projectState');
//   if (stored) {
//     try {
//       const parsed = JSON.parse(stored);
//       return {
//         selectedProject: parsed.selectedProject || null,
//         selectedProjectId: parsed.selectedProjectId || null,
//         selectedClient: parsed.selectedClient || null,
//         participants: { participants_list: [] }, // Do not persist participants
//         loading: false,
//         error: null,
//         isAdmin: parsed.isAdmin || false
//       } as ProjectState;
//     } catch (e) {
//       console.error('Failed to parse projectState from localStorage', e);
//     }
//   }
//   return {
//     selectedProject: null,
//     selectedProjectId: null,
//     selectedClient: null,
//     participants: { participants_list: [] },
//     loading: false,
//     error: null,
//     isAdmin: false
//   };
// })();

// const initialState: ProjectState = persistedState;

// // --------------------
// // Async Thunk
// // --------------------

// export const fetchParticipantsList = createAsyncThunk(
//   'project/fetchParticipantsList',
//   async (payload: ParticipantsPayload, thunkAPI) => {
//     try {
//       const response = await axiosInstance.post<ParticipantsResponse>('participants/list', payload);
//       return response.data;
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch participants');
//     }
//   }
// );

// // --------------------
// // Slice
// // --------------------

// const projectSlice = createSlice({
//   name: 'project',
//   initialState,
//   reducers: {
//     setSelectedProject(
//       state,
//       action: PayloadAction<{ project: string; projectId: string; isAdmin?: boolean }>
//     ) {
//       const { project, projectId, isAdmin = false } = action.payload;
//       state.selectedProject = project;
//       state.selectedProjectId = projectId;
//       state.isAdmin = isAdmin;

//       // Persist only essential fields to localStorage
//       const persistState = {
//         selectedProject: state.selectedProject,
//         selectedProjectId: state.selectedProjectId,
//         selectedClient: state.selectedClient
//           ? {
//               label: state.selectedClient.label,
//               id: state.selectedClient.id,
//               email: state.selectedClient.email,
//               ndisNumber: state.selectedClient.ndisNumber
//             }
//           : null,
//         isAdmin: state.isAdmin
//       };

//       try {
//         localStorage.setItem('projectState', JSON.stringify(persistState));
//       } catch (error) {
//         console.error('Failed to save projectState to localStorage:', error);
//         localStorage.removeItem('projectState');
//       }
//     },
//     clearSelectedProject(state) {
//       state.selectedProject = null;
//       state.selectedProjectId = null;
//       state.selectedClient = null;
//       state.participants = { participants_list: [] };
//       state.loading = false;
//       state.error = null;
//       state.isAdmin = false;

//       // Persist only essential fields to localStorage
//       const persistState = {
//         selectedProject: null,
//         selectedProjectId: null,
//         selectedClient: null,
//         isAdmin: false
//       };

//       try {
//         localStorage.setItem('projectState', JSON.stringify(persistState));
//       } catch (error) {
//         console.error('Failed to save projectState to localStorage:', error);
//         localStorage.removeItem('projectState');
//       }
//     },
//     setSelectedClient(state, action: PayloadAction<Client | null>) {
//       state.selectedClient = action.payload;

//       // Persist only essential fields to localStorage
//       const persistState = {
//         selectedProject: state.selectedProject,
//         selectedProjectId: state.selectedProjectId,
//         selectedClient: state.selectedClient
//           ? {
//               label: state.selectedClient.label,
//               id: state.selectedClient.id,
//               email: state.selectedClient.email,
//               ndisNumber: state.selectedClient.ndisNumber
//             }
//           : null,
//         isAdmin: state.isAdmin
//       };

//       try {
//         localStorage.setItem('projectState', JSON.stringify(persistState));
//       } catch (error) {
//         console.error('Failed to save projectState to localStorage:', error);
//         localStorage.removeItem('projectState');
//       }
//     },
//     updateAdminStatus(state, action: PayloadAction<boolean>) {
//       state.isAdmin = action.payload;

//       // Persist only essential fields to localStorage
//       const persistState = {
//         selectedProject: state.selectedProject,
//         selectedProjectId: state.selectedProjectId,
//         selectedClient: state.selectedClient
//           ? {
//               label: state.selectedClient.label,
//               id: state.selectedClient.id,
//               email: state.selectedClient.email,
//               ndisNumber: state.selectedClient.ndisNumber
//             }
//           : null,
//         isAdmin: state.isAdmin
//       };

//       try {
//         localStorage.setItem('projectState', JSON.stringify(persistState));
//       } catch (error) {
//         console.error('Failed to save projectState to localStorage:', error);
//         localStorage.removeItem('projectState');
//       }
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchParticipantsList.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchParticipantsList.fulfilled,
//         (state, action: PayloadAction<ParticipantsResponse>) => {
//           state.loading = false;
//           state.participants = action.payload;
//         }
//       )
//       .addCase(fetchParticipantsList.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   }
// });

// // --------------------
// // Exports
// // --------------------

// export const { setSelectedProject, clearSelectedProject, setSelectedClient, updateAdminStatus } =
//   projectSlice.actions;

// export default projectSlice.reducer;




import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';

// --------------------
// Types & Interfaces
// --------------------

interface ParticipantsPayload {
  group_id: string;
  service_name_id: string;
  nested_component_id: string;
  email: string;
  roles: string[];
  client_name: string;
}

interface ParticipantsResponse {
  participants_list: { name: string; email: string; avatar?: string; ndisNumber?: string }[];
}

interface Client {
  label: string;
  id: number;
  email: string;
  avatar?: string;
  ndisNumber?: string;
}

interface ProjectState {
  selectedProject: string | null;
  selectedProjectId: string | null;
  selectedClient: Client | null;
  participants: ParticipantsResponse;
  loading: boolean;
  error: string | null;
  isAdmin: boolean;
}

// --------------------
// Initial State with persistence
// --------------------

const persistedProject = (() => {
  try {
    const stored = localStorage.getItem('selectedProject');
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        selectedProject: parsed.projectName || null,
        selectedProjectId: parsed.projectId || null,
        selectedClient: parsed.selectedClient || null,
        participants: { participants_list: [] }, // never persist participants
        loading: false,
        error: null,
        isAdmin: parsed.isAdmin || false
      } as ProjectState;
    }
  } catch (error) {
    console.error('Failed to load selectedProject from localStorage:', error);
  }

  // fallback default
  return {
    selectedProject: null,
    selectedProjectId: null,
    selectedClient: null,
    participants: { participants_list: [] },
    loading: false,
    error: null,
    isAdmin: false
  } as ProjectState;
})();

const initialState: ProjectState = persistedProject;

// --------------------
// Async Thunk
// --------------------

export const fetchParticipantsList = createAsyncThunk(
  'project/fetchParticipantsList',
  async (payload: ParticipantsPayload, thunkAPI) => {
    try {
      const response = await axiosInstance.post<ParticipantsResponse>('participants/list', payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch participants');
    }
  }
);

// --------------------
// Slice
// --------------------

const projectSlice = createSlice({
  name: 'homeTilesServices',
  initialState,
  reducers: {
    setSelectedProject(
      state,
      action: PayloadAction<{ project: string; projectId: string; isAdmin?: boolean }>
    ) {
      const { project, projectId, isAdmin = false } = action.payload;
      state.selectedProject = project;
      state.selectedProjectId = projectId;
      state.isAdmin = isAdmin;

      try {
        localStorage.setItem(
          'selectedProject',
          JSON.stringify({
            projectId: state.selectedProjectId,
            projectName: state.selectedProject,
            selectedClient: state.selectedClient,
            isAdmin: state.isAdmin
          })
        );
      } catch (error) {
        console.error('Failed to save selectedProject to localStorage:', error);
      }
    },

    clearSelectedProject(state) {
      state.selectedProject = null;
      state.selectedProjectId = null;
      state.selectedClient = null;
      state.participants = { participants_list: [] };
      state.loading = false;
      state.error = null;
      state.isAdmin = false;

      try {
        localStorage.removeItem('selectedProject');
        localStorage.removeItem('projectState');
        localStorage.removeItem('servicesState');
        localStorage.removeItem('selectedClient');
      } catch (error) {
        console.error('Failed to clear project data from localStorage:', error);
      }
    },

    setSelectedClient(state, action: PayloadAction<Client | null>) {
      state.selectedClient = action.payload;

      try {
        const currentProject = localStorage.getItem('selectedProject');
        if (currentProject) {
          const parsed = JSON.parse(currentProject);
          parsed.selectedClient = action.payload;
          localStorage.setItem('selectedProject', JSON.stringify(parsed));
        }
      } catch (error) {
        console.error('Failed to update selectedClient in localStorage:', error);
      }
    },

    updateAdminStatus(state, action: PayloadAction<boolean>) {
      state.isAdmin = action.payload;

      try {
        const currentProject = localStorage.getItem('selectedProject');
        if (currentProject) {
          const parsed = JSON.parse(currentProject);
          parsed.isAdmin = action.payload;
          localStorage.setItem('selectedProject', JSON.stringify(parsed));
        }
      } catch (error) {
        console.error('Failed to update admin status in localStorage:', error);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParticipantsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchParticipantsList.fulfilled,
        (state, action: PayloadAction<ParticipantsResponse>) => {
          state.loading = false;
          state.participants = action.payload;
        }
      )
      .addCase(fetchParticipantsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Reset everything on logout
      .addCase('loginSignup/logout', (state) => {
        state.selectedProject = null;
        state.selectedProjectId = null;
        state.selectedClient = null;
        state.participants = { participants_list: [] };
        state.loading = false;
        state.error = null;
        state.isAdmin = false;

        try {
          localStorage.removeItem('selectedProject');
          localStorage.removeItem('projectState');
          localStorage.removeItem('servicesState');
          localStorage.removeItem('selectedClient');
        } catch (error) {
          console.error('Failed to clear project data from localStorage:', error);
        }
      });
  }
});

// --------------------
// Exports
// --------------------

export const { setSelectedProject, clearSelectedProject, setSelectedClient, updateAdminStatus } =
  projectSlice.actions;

export default projectSlice.reducer;
